import * as SessionManagementChannel from '@tableau/microview-communication-service/lib/src/channelDefinitions/SessionManagementChannelDefinitions';

import {
    getSessionManagementServiceInstance,
    SessionManagementService,
} from '../../../src/sessionManagement/SessionManagementService';
import { ExtractEncryptionMode } from '../../commonInfra/utils/sites/SitePropertyTypes';


const sessionManagementService: SessionManagementService = getSessionManagementServiceInstance();

export function startListening(): () => void {
    const unsubscribeSessionSiteUrlNameChannel = startListeningToSessionSiteUrlNameChannel();
    const unsubscribeSessionUserIDChannel = startListeningToSessionUserIDChannel();
    const unsubscribeExtractEncryptEnabledChannel = startListeningToExtractEncryptEnabledOmniSwitchChannel();
    const unsubscribeExtractEncryptionModeForSiteChannel = startListeningToExtractEncryptionModeForSiteChannel();
    const unsubscribeCatalogOnSiteEnabledChannel = startListeningToCatalogOnSiteEnabledChannel();
    const unsubscribeCollectionsEnabledChannel = startListeningToCollectionsEnabledChannel();
    const unsubscribeMetricsOnSiteEnabledChannel = startListeningToMetricsOnSiteEnabledChannel();
    const unsubscribeNlpServiceEnabledChannel = startListeningToNlpServiceEnabledChannel();
    const unsubscribeAskDataModeChannel = startListeningToAskDataModeChannel();
    const unsubscribeIsSessionServerAdminChannelChannel = startListeningToIsSessionServerAdminChannel();
    const unsubscribeIsSessionSiteAdminChannelChannel = startListeningToIsSessionSiteAdminChannel();
    const unsubscribeIsLimitedUserVisibilityChannel = startListeningToIsLimitedUserVisibilityChannel();
    const unsubscribeIsOnlineEnvironmentChannel = startListeningToIsOnlineEnvironmentChannel();
    const unsubscribeIsCollectionsEnabledOnSiteChannel = startListeningToIsCollectionsEnabledOnSiteChannel();

    return () => {
        unsubscribeSessionSiteUrlNameChannel();
        unsubscribeSessionUserIDChannel();
        unsubscribeExtractEncryptEnabledChannel();
        unsubscribeExtractEncryptionModeForSiteChannel();
        unsubscribeCatalogOnSiteEnabledChannel();
        unsubscribeCollectionsEnabledChannel();
        unsubscribeMetricsOnSiteEnabledChannel();
        unsubscribeNlpServiceEnabledChannel();
        unsubscribeAskDataModeChannel();
        unsubscribeIsSessionServerAdminChannelChannel();
        unsubscribeIsSessionSiteAdminChannelChannel();
        unsubscribeIsLimitedUserVisibilityChannel();
        unsubscribeIsOnlineEnvironmentChannel();
        unsubscribeIsCollectionsEnabledOnSiteChannel();
    };
}

export function startListeningToSessionSiteUrlNameChannel(): () => void {
    const sessionSiteUrlNameChannel = new SessionManagementChannel.SessionSiteUrlNameChannel();
    return sessionSiteUrlNameChannel.listen(() => {
        return { seassionSiteUrlName: sessionManagementService.sessionSiteUrlName() };
    });
}

export function startListeningToExtractEncryptEnabledOmniSwitchChannel(): () => void {
    const extractEncryptEnabledChannel = new SessionManagementChannel.ExtractEncryptionEnabledOmniSwitchChannel();
    return extractEncryptEnabledChannel.listen(() => {
        return {
            extractEncryptionEnabled: sessionManagementService.isExtractEncryptionEnabledOmniSwitch()
        };
    });
}

export function startListeningToExtractEncryptionModeForSiteChannel(): () => void {
    const extractEncryptionModeForSiteChannel = new SessionManagementChannel.ExtractEncryptionModeForSiteChannel();
    return extractEncryptionModeForSiteChannel.listen(() => {
        const extractEncryptionMode = sessionManagementService.getExtractEncryptionModeForSite();
        return { extractEncryptionMode: mapExtractEncryptionMode(extractEncryptionMode) };
    });
}

export function startListeningToCatalogOnSiteEnabledChannel(): () => void {
    const catalogOnsiteEnabledChannel = new SessionManagementChannel.CatalogOnsiteEnabledChannel();
    return catalogOnsiteEnabledChannel.listen(() => {
        return { catalogOnsiteEnabled: sessionManagementService.catalogingOnSiteEnabled() };
    });
}

export function startListeningToCollectionsEnabledChannel(): () => void {
    const collectionsEnabledChannel = new SessionManagementChannel.CollectionsEnabledChannel();
    return collectionsEnabledChannel.listen(() => {
        return { collectionsEnabled: sessionManagementService.isCollectionsEnabledOnSite() };
    });
}

export function startListeningToMetricsOnSiteEnabledChannel(): () => void {
    const metricsOnsiteEnabledChannel = new SessionManagementChannel.MetricsOnSiteEnabledChannel();
    return metricsOnsiteEnabledChannel.listen(() => {
        return { metricsOnSiteEnabled: sessionManagementService.isMetricsEnabledOnSite() };
    });
}

export function startListeningToNlpServiceEnabledChannel(): () => void {
    const nlpServiceEnabledChannel = new SessionManagementChannel.NlpServiceEnabledChannel();
    return nlpServiceEnabledChannel.listen(() => {
        return { isNlpServiceEnabled: sessionManagementService.isNlpServiceEnabled() };
    });
}

export function startListeningToAskDataModeChannel(): () => void {
    const askDataModeChannel = new SessionManagementChannel.AskDataModeChannel();
    return askDataModeChannel.listen(() => {
        return { askDataMode: sessionManagementService.askDataMode() };
    });
}

export function startListeningToSessionUserIDChannel(): () => void {
    const sessionUserIDChannel = new SessionManagementChannel.SessionUserIDChannel();
    return sessionUserIDChannel.listen(() => {
        return { sessionUserId: sessionManagementService.sessionUserId() };
    });
}

export function startListeningToIsSessionServerAdminChannel(): () => void {
    const isSessionServerAdminChannel = new SessionManagementChannel.IsSessionServerAdminChannel();
    return isSessionServerAdminChannel.listen(() => {
        return { isSessionServerAdmin: sessionManagementService.isSessionServerAdmin() };
    });
}

export function startListeningToIsSessionSiteAdminChannel(): () => void {
    const isSessionSiteAdminChannel = new SessionManagementChannel.IsSessionSiteAdminChannel();
    return isSessionSiteAdminChannel.listen(() => {
        return { isSessionSiteAdmin: sessionManagementService.isSessionSiteAdmin() };
    });
}

export function startListeningToIsLimitedUserVisibilityChannel(): () => void {
    const isSessionSiteAdminChannel = new SessionManagementChannel.IsLimitedUserVisibilityChannel();
    return isSessionSiteAdminChannel.listen(() => {
        return { isUserLimitedVisibility: sessionManagementService.isLimitedUserVisibilityEnforced() };
    });
}

export function startListeningToIsOnlineEnvironmentChannel(): () => void {
    const isOnlineEnvironmentChannel = new SessionManagementChannel.IsOnlineEnvironmentChannel();
    return isOnlineEnvironmentChannel.listen(() => {
        return { isOnlineEnvironment: sessionManagementService.isOnlineEnvironment() };
    });
}

export function startListeningToIsCollectionsEnabledOnSiteChannel(): () => void {
    const isCollectionsEnabledOnSiteChannel = new SessionManagementChannel.IsCollectionsEnabledOnSiteChannel();
    return isCollectionsEnabledOnSiteChannel.listen(() => {
        return { isCollectionsEnabledOnSite: sessionManagementService.isCollectionsEnabledOnSite() };
    });
}

/*
    This function maps the VPC's ExtractEncryptionMode to the communication channel's
    ExtractEncryptionMode (SessionManagement.ExtractEncryptionMode)
*/

function mapExtractEncryptionMode(vpcExtractMode: ExtractEncryptionMode): SessionManagementChannel.ExtractEncryptionMode {
    switch (vpcExtractMode) {
        case ExtractEncryptionMode.DISABLED:
            return SessionManagementChannel.ExtractEncryptionMode.DISABLED;
        case ExtractEncryptionMode.ENABLED:
            return SessionManagementChannel.ExtractEncryptionMode.ENABLED;
        case ExtractEncryptionMode.ENFORCED:
            return SessionManagementChannel.ExtractEncryptionMode.ENFORCED;
    }
}
